import { getJsonPayload } from "@omni/utils/dom.utils";
import md5 from "md5";

const elementHasBeenTracked = (element: HTMLElement): boolean => {
    return element?.dataset?.trackingDone === "true";
};

const setElementHasBeenTracked = (element: HTMLElement): void => {
    if (element?.dataset) element.dataset.trackingDone = "true";
};

const hasTrackingEventSuffix = (element: HTMLElement, suffix: string) => {
    return element.dataset.trackingEvent?.endsWith(suffix);
};

const findClosestContext = (element: HTMLElement) => {
    const closest = element.closest(
        "[data-tracking-event='section-impression']"
    ) as HTMLElement;

    if (closest) {
        return getJsonPayload(closest, "trackingInfo");
    }
};

const createUserId = (email: string) => md5(email);

export {
    createUserId,
    elementHasBeenTracked,
    findClosestContext,
    hasTrackingEventSuffix,
    setElementHasBeenTracked
};
